import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DEFAULT_DATE_TIME_FORMAT } from 'src/app/core/ccomx-date-formats';
import { MatDialog } from '@angular/material/dialog';
import { select, Store } from '@ngxs/store';
import { TenantUserAccessState } from 'src/app/tenant-selector/state/tenant-user-access.state';
import { TenantUserPrivilegesService } from 'src/app/tenant-selector/services/tenant-user-privileges.service';
import { CommentAttachmentsDialogComponent } from '../comment-attachments-dialog/comment-attachments-dialog.component';
import { IComment } from '../model/comment.model';
import { DeleteComment, UpdateComment } from '../state/comments.actions';

@Component({
  selector: 'app-comment-item',
  templateUrl: './comment-item.component.html',
  styleUrls: ['./comment-item.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentItemComponent implements OnInit {
  @Input() comment: IComment;
  @Input() entityType: number;
  @Input() entityId: string;
  @Input() showDivider: boolean = true;
  @Input() privilege: string;
  @Input() adminPrivilege: string;
  @Input() canEditOwnComment = false;
  @Input() canDeleteOwnComment = false;
  @Input() isInPopup = false;
  @Input() isPOMode = false;
  @Input() showDeleteButton = true;

  userAccess = select(TenantUserAccessState.userAccess);

  deleteAction = [DeleteComment];
  updateAction = [UpdateComment];
  dateTimeFormat = DEFAULT_DATE_TIME_FORMAT;

  isEditMode = false;
  hasAdminPrivilege = false;

  constructor(
    private store: Store,
    private dialog: MatDialog,
    private tenantUserPrivileges: TenantUserPrivilegesService
  ) {}

  ngOnInit(): void {
    this.hasAdminPrivilege = this.tenantUserPrivileges.userHasPrivilege(this.adminPrivilege);
  }

  deleteComment(id: string): void {
    this.store.dispatch(new DeleteComment(this.entityType, this.entityId, id, this.isInPopup));
  }

  editComment(): void {
    this.isEditMode = true;
  }

  cancelEdit(): void {
    this.isEditMode = false;
  }

  openAttachmentsDialog(): void {
    if (this.comment.attachments?.length) {
      this.dialog.open(CommentAttachmentsDialogComponent, {
        data: { attachments: this.comment.attachments },
        panelClass: 'mobile-sizing-for-mat-dialogs',
      });
    }
  }
}
